import { render, staticRenderFns } from "./Viruses.vue?vue&type=template&id=05ec44c9&scoped=true&"
import script from "./Viruses.vue?vue&type=script&lang=ts&"
export * from "./Viruses.vue?vue&type=script&lang=ts&"
import style0 from "./Viruses.vue?vue&type=style&index=0&id=05ec44c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ec44c9",
  null
  
)

export default component.exports